export const NEWS = 'News';
